import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useDeleteAIAgentTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: any) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			id,
			impersonationContext,
		}: {
			id: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `aiagenttemplate/${id}` }),
				'DELETE'
			);
		},
		onSuccess,
		onError,
	});
}
